<template>
  <div class="page-container" ref="roseApple" id="roseApplecontainer" v-images-loaded="loaded">
    <div class="bigscroller">
      <router-link  class="home-icon-container" :to="{ name: 'home' }"> 
        <img class="home-icon" :src="homeIcon" alt="home">
      </router-link>
      <Menu />
      <MobileMenu />
      <section id="roseApple">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="bannerRose"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="ritualRose">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="ritualRose"></router-view>
        <router-view name="dritualRose"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="mixologiaRose">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="mixologiaRose"></router-view>
        <router-view name="dmixologiaRose"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="maridajeRose">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="maridajeRose"></router-view>
        <router-view name="othersRose"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <div class="mRetailers">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import MobileMenu from "@/components/MobileMenu";
import VueScrollTo from "vue-scrollto";
import { mapActions, mapGetters } from "vuex";
import Footer from "@/components/FooterHome";
import tagFunctions from '@/utils/tagFunctions.js'
import homeIcon from "@/assets/home-icon.png"
import imagesLoaded from 'vue-images-loaded'

export default {
  name: "roseApple",
  props: ["id"],
  components: {
    Menu,
    MobileMenu,
    Footer,


  },
    directives: {
    imagesLoaded
},
  computed: {
    ...mapGetters([
      "getActiveSection",
      "getTriggerSpring",
      "getEdgeScrolling",
      "getScrollMotion",
    ]),
  },
  created() {},
  data() {
    return {
      baseRoute: 'roseApple',
      showModal: false,
      wichModal: "terms",
      fixedLel: true,
      homeIcon
    };
  },
  mounted() {
    this.setLoadStatus({status: false})
    tagFunctions.evPageViewPush('Rose Apple')
    //this.checkRouteForInitialScroll();
    VueScrollTo.scrollTo(`#app`, 1, {
          container: "body",
          easing: "linear",
          offset: 0,
          force: true,
          cancelable: true,
          // onStart: function(element) {},
          // onDone: function(element) {},
          // onCancel: function() {},
          x: false,
          y: true,
        });
  },
  methods: {
     loaded(){
      this.setLoadStatus({status: true})
    },
    ...mapActions({
      goToSection: "goToSection",
      setActiveSection: "setActiveSection",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setEdgeScrollingAction: "setEdgeScrolling",
            setLoadStatus: "setLoadStatus"
    }),
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
      this.$router.push({ name: entry.target.offsetParent.id }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
        this.setActiveSection({
          willScroll: false,
          section: entry.target.offsetParent.id==this.$route.name?'':this.baseRoute+'/'+entry.target.offsetParent.id,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/containers/RoseApple.scss";
@import "~@/styles/variables.scss";
</style>